import { render, staticRenderFns } from "./LegalTermsNossaPraia.vue?vue&type=template&id=7401a9df&scoped=true&"
import script from "./LegalTermsNossaPraia.vue?vue&type=script&lang=js&"
export * from "./LegalTermsNossaPraia.vue?vue&type=script&lang=js&"
import style0 from "./LegalTermsNossaPraia.vue?vue&type=style&index=0&id=7401a9df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7401a9df",
  null
  
)

export default component.exports